module.exports = __webpack_public_path__ + "static/img/04.1fc023d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/04.png
// module id = L9Wr
// module chunks = 1